// extracted by mini-css-extract-plugin
module.exports = {"container":"CompaniesForm_container__3O-vF","info":"CompaniesForm_info__2F7hS","error":"CompaniesForm_error__30s46","transferList":"CompaniesForm_transferList__3OBff"};